import { ChartOptions } from "chart.js";

export function chartPerformanceTeamOptions(): ChartOptions {
  return {
    maintainAspectRatio: false,
    responsive: true,
    hover: {
      mode: null
    },
    plugins: {
      datalabels: {
        display: false
      }
    },
    scales: {
      xAxes: [{
        position: 'top',
        gridLines: {
          display: true,
          drawBorder: false
        },
        ticks: {
          suggestedMax: 10,
          display: true,
          beginAtZero: true,
          callback
        }
      }],
      yAxes: [{
        gridLines: {
          display: false
        }
      }]
    },
    tooltips: {
      callbacks: {
        title,
        label
      },
      backgroundColor: '#403D3D',
      titleFontSize: 12,
      titleFontColor: '#fff',
      bodyFontColor: '#fff',
      bodyFontSize: 12,
      displayColors: false,
      xPadding: 10,
      yPadding: 10,
      bodySpacing: 4,
      position: 'nearest',
    }
  };
};

export function title(tooltipItem): any {
  const sum = tooltipItem.reduce((partialSum, a) => partialSum + +a.value, 0);
  return sum + ' FAC(s)';
}

export function label(tooltipItem, data): any {
  const label = `${tooltipItem.value} ${data.datasets[tooltipItem.datasetIndex].label.toLocaleLowerCase()}(s)`;
  return label;
}

export function callback(value: number) { 
  if (value % 1 === 0) { 
    return value; 
  } 
}